import { render } from "./UnCryptoV1.0.vue?vue&type=template&id=2669dfae&scoped=true"
import script from "./UnCryptoV1.0.vue?vue&type=script&lang=js"
export * from "./UnCryptoV1.0.vue?vue&type=script&lang=js"

import "./UnCryptoV1.0.vue?vue&type=style&index=0&id=2669dfae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2669dfae"]])

export default __exports__